import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Overview from './views/Overview'
import RecordsAndFiles from './views/RecordsAndFiles'
import SourcesAndSync from './views/SourcesAndSync'
// import ActivityLogs from './views/ActivityLogs'
import AnalyticsAndReports from './views/AnalyticsAndReports'
// import BackupAndRecovery from './views/BackupAndRecovery'
// import Encryption from './views/Encryption'
// import PolicyAndCompliances from './views/PolicyAndCompliances'
// import QueryAndPrompt from './views/QueryAndPrompt'
import FileDetails from './components/RecordsAndFiles/FileDetails'
import FileRequest from './components/RecordsAndFiles/FileRequest'
import AuditsAndLogs from './views/AuditsAndLogs'
import SettingsAndPolicies from './views/SettingsAndPolicies'
import RecordsClassifications from './views/RecordsClassification'
import RecentlyVisitedFiles from './views/RecentlyVisitedFiles'
import MostVisitedFolders from './views/MostVisitedFolders'
import RecentUpload from './views/RecentUpload'
import ArchievedFiles from './views/ArcheivedFiles'
import SearchAndFilters from './views/SearchAndFilters'
import SyncLog from './components/SourceAndSync/SyncLog'

export const RecordsKeeperAIRoutes = () => {
  // const { formatMessage } = useIntl()
  return (
    <div className='mt-3'>
      <Routes>
        <Route
          path='overview'
          element={
            <>
              <Overview />
            </>
          }
        />
        <Route path='overview/recently-visited-files' element={<RecentlyVisitedFiles />} />
        <Route path='overview/most-visited-folders' element={<MostVisitedFolders />} />
        <Route path='overview/recent-uploads' element={<RecentUpload />} />
        <Route
          path='records-and-files/*'
          element={
            <>
              <RecordsAndFiles />
            </>
          }
        />
        <Route path='records-and-files/files-request' element={<FileRequest />} />
        <Route path='records-and-files/files-details' element={<FileDetails />} />
        <Route path='records-and-files/archieved-files' element={<ArchievedFiles />} />

        <Route
          path='search-and-filters'
          element={
            <SearchAndFilters />
          }
        />

        <Route
          path='/records-and-files/files-details/:recordId'
          element={<FileDetails />}
        />

        <Route
          path='sources-and-sync/*'
          element={
            <>
              <SourcesAndSync />
            </>
          }
        />
        <Route path='sources-and-sync/sync-log' element={<SyncLog />} />
        <Route
          path='records-classifications'
          element={
            <>
              <RecordsClassifications />
            </>
          }
        />
        <Route
          path='analytics-and-reports'
          element={
            <>
              <AnalyticsAndReports />
            </>
          }
        />
        <Route
          path='setting-and-policy'
          element={
            <>
              <SettingsAndPolicies />
            </>
          }
        />
        {/* <Route
                    path='policy-and-compliances'
                    element={
                        <>
                            <PolicyAndCompliances />
                        </>
                    }
                />
                <Route
                    path='backup-and-recovery'
                    element={
                        <>
                            <BackupAndRecovery />
                        </>
                    }
                /> */}
        {/* <Route
                    path='encryption'
                    element={
                        <>
                            <Encryption />
                        </>
                    }
                /> */}
        {/* <Route
                    path='activity-logs'
                    element={
                        <>
                            <ActivityLogs />
                        </>
                    }
                /> */}
        <Route
          path='audits-and-logs'
          element={
            <>
              <AuditsAndLogs />
            </>
          }
        />
      </Routes>
    </div>
  )
}
